/** Fase 2 de rendimiento (prerender extendido, ver scripts/prerender-content.mjs y CLAUDE.md) —
 *  evaluado una sola vez, al cargar este módulo, ANTES de que React monte nada: si `<div
 *  id="root">` ya tiene hijos es porque esta página vino de un `dist/<ruta>/index.html`
 *  prerenderizado (contenido real, no el shell vacío de siempre). __root.tsx lo usa para saltear
 *  el `<Suspense>` que envuelve `<Outlet/>` SOLO en el primer render (hidratación) — ver el
 *  comentario largo en __root.tsx sobre por qué hidratar un `<Suspense>` sin el protocolo de
 *  comentarios especiales de un SSR real (`<!--$-->`/`<!--/$-->`) rompe con "Minified React
 *  error #418", sin importar si termina suspendiéndose o no. */
export const wasPrerendered = typeof document !== "undefined" && !!document.getElementById("root")?.hasChildNodes();
